import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Subject, catchError, lastValueFrom, of, takeUntil, tap } from 'rxjs';

import { ContactService } from '../../../../contacts/contactService';
import { AppMainComponent } from '../../../../app.main.component';
import { AppMainService } from '../../../../app-main.service';
import { ChannelN } from '../../../../modules/shared/models/channel.model';
import { ConfigurationService } from '../../../../configurations/configurationService';
import { MessageService } from 'primeng/api';
import { TypeGroupIds } from 'src/app/modules/shared/constants/category-groupid.constants';
import { Status } from '../../../../models/statusEnums';
import {
  CONTACT_ASSOCIATION_ID,
  EMAIL_TYPE_IDS,
  PHONE_TYPE_IDS,
} from '../../../../modules/shared/constants/typeId';
import { COUNTRY_CODE } from '../../data/country-code';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Tag } from '../../../../accounts-v2/models/tag.model';
import { AccountServiceN } from '../../../../accounts-v2/services/account.services';
import { AccountUserService } from 'src/app/service/account.service';
import { WhatsAppService } from '../../services/whatsapp.service';
import { PhoneNumberFormatModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { ContactFieldService } from 'src/app/configurations/crm/contacts/contact.service';
import { PhoneNumberFormatService } from '../../../../modules/shared/services/phone-number-format.service';


@Component({
  selector: 'app-add-edit-contacts-list',
  templateUrl: './add-edit-contacts-list.component.html',
  styleUrls: ['./add-edit-contacts-list.component.scss'],
})
export class AddEditContactsListComponent implements OnInit, OnChanges {
  @Input() display;
  @Input() contactHeader;
  @Input() contactTypes;
  @Input() selectedContactType;
  @Input() selectedContact;
  @Input() selectedPhone:{
    countryName: string;
    countryCode: number;
    phoneNumber: string;
  };
  @Output() contactTypeCreated = new EventEmitter<string>();
  @Output() contactCreated = new EventEmitter<string>();
  @Output() cancelClicked = new EventEmitter();

  areaCodes = COUNTRY_CODE;
  phoneNumberFormat: any;

  contactAssociation: any[] = [];
  associationNames: any[];
  allAssociationNamesList: any[] = [];
  selectedChannelN: ChannelN;
  countryData: any;
  selectedCountry: any = "";
  maskingDisabled: boolean= false



  contactTypesNew: any[] = [];
  displayNewContactType = false;
  newType = { id: 0, name: 'New Contact Type', statusId: 1 };
  tempContactType = {
    id: 0,
    name: '',
    description: '',
    isActive: true,
  };
  salutations: any[] = [];
  selectedContactSource = null;
  selectedSalutation = null;

  sources = [];

  contactTemp = {
    id: 0,
    createdSource: this.app.userIP,
    createdBy: this.app.user.userId,
    createdDate: new Date(),
    firstName: '',
    middleName: '',
    lastName: '',
    title: '',
    contactTypeId: 0,
    associationId: this.app.user.organizationId,
    associationName: this.app.user.organizationName,
    contactAssociationTypeId: CONTACT_ASSOCIATION_ID.ORGANIZATION,
    contactEmails: [
      {
        id: 0,
        createdSource: this.app.userIP,
        createdBy: this.app.user.userId,
        createdDate: new Date(),
        contactId: 0,
        emailId: 0,
        email: {
          id: 0,
          createdSource: this.app.userIP,
          createdBy: this.app.user.userId,
          createdDate: new Date(),
          emailAddress: '',
          description: '',
          emailTypeId: EMAIL_TYPE_IDS.WORK,
          statusId: Status.Active,
        },
      },
    ],
    contactPhones: [
      {
        id: 0,
        createdSource: this.app.userIP,
        createdBy: this.app.user.userId,
        createdDate: new Date(),
        contactId: 0,
        phoneId: 0,
        phone: {
          id: 0,
          createdSource: this.app.userIP,
          createdBy: this.app.user.userId,
          createdDate: new Date(),
          number: '',
          extension: '',
          description: '',
          phoneTypeId: PHONE_TYPE_IDS.WORK,
          statusId: Status.Active,
          country: null,
          code: null
        },
      },
    ],
    contactProfileImages: [],
    organizationId: this.app.user.organizationId,
    statusId: Status.Active,
  };
  contactDetail: any;

  contactForm: FormGroup;
  isView = false;

  constructor(
    private fb: FormBuilder,
    private contactService: ContactService,
    public app: AppMainComponent,
    private appMainService: AppMainService,
    private configurationService: ConfigurationService,
    private messageService: MessageService,
    private accountService: AccountServiceN,
    private accountUserService: AccountUserService,
    private whatsAppService: WhatsAppService,
    private contactFieldService: ContactFieldService,
    private phoneNumberFormatService: PhoneNumberFormatService
  ) {
    this.contactForm = this.fb.group({
      selectedContactType: [null, [Validators.required]],
      salutation: [null],
      firstName: ['', [Validators.required]],
      middleName: [''],
      lastName: [''],
      email: ['', [Validators.email]],
      code: ['', [Validators.required]],
      phone: [null, [Validators.required]],
      selectedContactSource: [null],
      companyName:[''],
    });
  }

  //tag
  tags: Tag[] = [];
  isEditTag = false;
  displayAddTag = false;
  tagList: Tag[] = [];
  selectedValues: any[] = [];
  pageSize: number = 5;
  filterDropdownList: { name: string; id: number }[] = [
    { name: 'Assigned', id: 1 },
    { name: 'UnAssigned', id: 2 },
    { name: 'All', id: 3 },
  ];
  first: number = 0;
  displayCreateTag: boolean = false;

  // Subject to unsubscribe
  private ngUnsubscribe = new Subject<void>();

  async ngOnInit(): Promise<void> {
    this.loadTages();
    if (this.selectedContact) {
      const { mode, contact } = this.selectedContact;
      if (mode === 'view') {
        this.contactForm.disable();
        this.isView = true;
      }
      if(contact?.id){
        this.getContactDetail(contact);
      }
      const contactType = this.contactTypes?.find(
        (ct) => ct?.name?.toLowerCase() === contact?.contactType?.toLowerCase()
      );
      // this.getCountryCode(contact.phone);
      this.getPhoneNumberTemplate();
      this.getTitles(contact);
      this.contactForm.patchValue({
        selectedContactType: contactType,
        firstName: contact?.firstName,
        middleName: contact?.MiddleName,
        lastName: contact?.lastName,
        email: contact?.email,
      });

      // remove country code validation
      if (contact?.phone) {
        const control = this.contactForm.get('code');
        control?.setValidators(null);
        control?.updateValueAndValidity();
      }
    } else {
      await this.getTitles();
      this.getPhoneNumberTemplate();
    }
    this.getCountryCode();
    await this.getContactAsso();
    this.getContactTypes();
    await this.loadContactSources();

  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes.contactTypes && changes.contactTypes.currentValue) {
    //   this.contactTypesNew =
    //     changes.contactTypes.currentValue.filter((el) => el.statusId == 1) ||
    //     [];
    //   this.setDefaultContactType();

    //   this.contactTypesNew.push(this.newType);
    // }
    if (changes.selectedContact && changes.selectedContact.currentValue) {
      this.selectedContact = changes.selectedContact.currentValue;
      this.getContactTypes();

    }

    if (changes.selectedPhone && changes.selectedPhone.currentValue) {
      this.selectedPhone = changes.selectedPhone.currentValue;
    }
  }

  getContactTypes() {
    this.appMainService.isShowSpinner('getContactTypes');
    this.contactService.getAllContactType().subscribe({
      next: (res) => {
        this.contactTypesNew = res || [];
        this.setDefaultContactType();
        this.contactTypesNew.push(this.newType);
        this.appMainService.isHideSpinner('getContactTypes');
      },
      error: (err) => {
        this.appMainService.isHideSpinner('getContactTypes');
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.message });
      }
    });
  }

  async getContactAsso() {
    this.contactAssociation =
      await this.contactService.getAllContactAssociation();
  }

  async loadContactSources() {
    this.sources = await this.contactService.getAllContactSource();
    this.selectedContactSource = this.sources.find((s) => s.isDefault);
  }

  async getTitles(contact?) {
    this.salutations = await lastValueFrom(
      this.contactService.getSalutations()
    );
    if(contact?.title){
      const salutation = this.salutations.find(
        (s) => s.name.toLowerCase() === contact?.title?.toLowerCase()
      );
      this.contactForm.patchValue({
        salutation: salutation
      });
    }

  }

  async getContactDetail(contact) {
    this.appMainService.isShowSpinner('contactDetails');
    this.contactDetail = await this.contactService.getContactById(
      contact?.id,
      contact?.contactAssociationTypeId
    );
    const data = this.contactDetail?.contactPhones[0];
    let dataSources = this.sources.find((s) => s.id === this.contactDetail?.sourceId);
    this.tags = this.contactDetail?.contactTag;
    this.maskingDisabled = this.phoneNumberFormatService.checkMaskingDisabled(data?.phone?.number);
    this.contactForm.patchValue({
      phone: data?.phone?.number,
      middleName: this.contactDetail?.middleName,
      selectedContactSource: dataSources,
      companyName:this.contactDetail?.companyName,
    });
    this.getCountryCode(data);
    this.appMainService.isHideSpinner('contactDetails');
  }

  enableContactEdit() {
    this.selectedContact.mode = 'edit';
    this.contactHeader = 'Edit Contact';
    this.isView = false;
    this.contactForm.enable();

  }

  setDefaultContactType() {
    let defaultType = null;
    if (this.selectedContactType && this.selectedContact) {
      defaultType = this.contactTypesNew?.find(
        (c) => c?.name === this.selectedContact?.contact?.contactType
      );
    } else {
      defaultType = this.contactTypesNew.find((c) => c?.isDefault);
    }

    if (defaultType) {
      this.contactForm.patchValue({
        selectedContactType: defaultType,
      });
    }
  }

  changeContactType() {
    const type = this.contactForm.value.selectedContactType;
    if (type?.name == 'New Contact Type') {
      this.newContactType();
      this.setDefaultContactType();
    }
  }

  newContactType() {
    this.tempContactType = {
      id: 0,
      name: '',
      description: '',
      isActive: true,
    };
    this.displayNewContactType = true;
  }

  async saveNewContact() {
    if (this.contactForm.invalid) return;
    const value = this.contactForm.getRawValue();
    const data = {
      ...this.contactTemp,
      title: value.salutation?.name ?? '',
      firstName: value.firstName,
      middleName: value.middleName,
      lastName: value.lastName,
      salutationId: value.salutation?.id,
      contactTypeId: value.selectedContactType?.id,
      sourceId: value.selectedContactSource?.id,
      contactTag:this.tags,
      companyName:value.companyName,
    };
    if(value.email){
      data.contactEmails[0].email.emailAddress = value.email;
    }else{
      data.contactEmails = null;
    }
    const phoneNumber = this.phoneNumberFormatService.removeMaskingFromNumber(value.phone);
    data.contactPhones[0].phone.number = `${value.code?.PhoneCode||''}${phoneNumber}`;
    data.contactPhones[0].phone.country = value.code?.CountryName;
    data.contactPhones[0].phone.code = value.code?.PhoneCode;

    try {
      this.appMainService.isShowSpinner('addNewContact');
      await this.contactService.addContact(data);
      this.appMainService.isHideSpinner('addNewContact');
      this.contactCreated.emit(value.selectedContactType.name);
      this.close();
    } catch {
      this.appMainService.isHideSpinner('addNewContact');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Error occurred while create contact...',
      });
    }
  }

  async updateContact(str?: string) {
    if (this.contactForm.invalid) return;
    const selectedContact = this.selectedContact.contact;
    const value = this.contactForm.getRawValue();
    const contact = {
      ...this.contactDetail,
      id: selectedContact?.id,
      salutationId: value.salutation?.id,
      title: value.salutation?.name ?? '',
      firstName: value.firstName,
      middleName: value.middleName,
      lastName: value.lastName,
      contactTypeId: value.selectedContactType.id,
      contactTag: this.tags,
      companyName:value.companyName,
    };
    if(value.email){
      if (contact.contactEmails[0]?.email) {
        contact.contactEmails[0].email.emailAddress = value.email;
      } else {
        contact.contactEmails.push({
          id: 0,
          createdSource: this.app.userIP,
          createdBy: this.app.user.userId,
          createdDate: new Date(),
          contactId: 0,
          emailId: 0,
          email: {
            id: 0,
            createdSource: this.app.userIP,
            createdBy: this.app.user.userId,
            createdDate: new Date(),
            emailAddress: value.email,
            description: '',
            emailTypeId: EMAIL_TYPE_IDS.WORK,
            statusId: Status.Active,
          },
        });
      }
    }else{
      contact.contactEmails = null;
    }

    const phoneNumber = this.phoneNumberFormatService.removeMaskingFromNumber(value.phone);

    if (contact.contactPhones[0]?.phone) {
      contact.contactPhones[0].phone.number =
        `${value.code?.PhoneCode||''}${phoneNumber}`.trim();
        contact.contactPhones[0].phone.code = value.code?.PhoneCode;
        contact.contactPhones[0].phone.country = value.code?.CountryName;
    } else {
      contact.contactPhones.push({
        id: 0,
        createdSource: this.app.userIP,
        createdBy: this.app.user.userId,
        createdDate: new Date(),
        contactId: 0,
        phoneId: 0,
        phone: {
          id: 0,
          createdSource: this.app.userIP,
          createdBy: this.app.user.userId,
          createdDate: new Date(),
          number: `${value.code?.PhoneCode}${phoneNumber}`.trim(),
          extension: '',
          description: '',
          phoneTypeId: PHONE_TYPE_IDS.WORK,
          statusId: Status.Active,
        },
      });
    }

    if (!contact?.territories) {
      contact.territories = null;
    } else {
      contact.territories.map((territoryObj) => {
        if (!territoryObj.statusId) {
          territoryObj.statusId = Status.Active;
        }
        if (!territoryObj.organizationId) {
          territoryObj.organizationId = this.app.user.organizationId;
        }
      });
    }
    contact.sourceId = value.selectedContactSource?.id || null;
    try {
      this.appMainService.isShowSpinner('updateContact');
      await this.contactService.updateContact(contact);
      this.appMainService.isHideSpinner('updateContact');
      this.contactCreated.emit(value.selectedContactType.name);
      if(str === 'view'){
        this.isView = true;
        this.selectedContact.mode = 'view';
        this.contactHeader = 'View Contact';
      } else {
        this.close();
        this.isView = false;
      }
    } catch {
      this.appMainService.isHideSpinner('updateContact');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Error occurred while updating contact...',
      });
    }
  }

  async saveContactType() {
    this.contactTypesNew.pop();
    this.appMainService.isShowSpinner('createContactType');
    let data = {
      name: this.tempContactType.name,
      description: this.tempContactType.description,
      organizationId: this.app.user.organizationId,
      statusId: this.tempContactType.isActive ? 1 : 2,
      createdSource: this.app.userIP,
      groupId: TypeGroupIds.ContactType,
    };

    try {
      const newContactType =
        await this.configurationService.addContactType(data);
      this.contactForm.get('selectedContactType').setValue(newContactType);

      this.contactTypesNew.push(newContactType);
      this.contactTypesNew.push(this.newType);
      this.displayNewContactType = false;
      this.appMainService.isHideSpinner('createContactType');
      this.contactTypeCreated.emit(newContactType.name);
    } catch {
      this.appMainService.isHideSpinner('createContactType');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Error occurred while create data...',
      });
      this.displayNewContactType = false;
    }
  }

  close() {
    this.cancelClicked.emit();
  }

  //tag
  removeTag(i) {
    this.tags.splice(i, 1);
  }

  addTag() {
    this.displayAddTag = true;
    if (this.tags?.length > 0) {
      this.tags = JSON.parse(JSON.stringify(this.removeDuplicates(this.tags)));
      this.selectedValues = this.tags;
    }
  }
  removeDuplicates(arr: Tag[]): Tag[] {
    const uniqueSet = new Set();

    return arr.filter((obj) => {
      const objString = JSON.stringify(obj);
      if (!uniqueSet.has(objString)) {
        uniqueSet.add(objString);
        return true;
      }
      return false;
    });
  }
  saveTag(tags: Tag[]) {
    if (tags.length > 0) {
      this.tags = JSON.parse(
        JSON.stringify(this.removeDuplicates(this.selectedValues))
      );
    }
  }
  loadTages() {
    this.whatsAppService
      .getAllTags()
      .pipe(
        tap((tags) => {
          const filteredTags = tags.filter((data) => data?.statusId == 1);
          this.tagList = JSON.parse(JSON.stringify(filteredTags));
        }),
        catchError(() => of([])),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe();
  }

  createTag(tag: Tag): void {
    tag.statusId = 1;
    this.contactFieldService
      .addTags(tag)
      .pipe(
        tap((tag: Tag) => {
          if (tag !== null) {
            this.loadTages();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Added Successfully...',
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Duplicate tag names are not allowed.',
            });
          }
          this.displayCreateTag = false;
        }),
        catchError(() => of(null)),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe();
  }

  openCreateTagDialog() {
    this.displayCreateTag = true;
  }

  assignSelectedTags(tags: Tag[]) {
    if (tags.length > 0) {
      this.tags = JSON.parse(JSON.stringify(this.removeDuplicates(tags)));
    }
    this.displayAddTag = false;
  }

  getCountryCode(data?) {
    this.accountUserService.countryCode().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        {
          next: (response) => {
            this.countryData = response;
            if(data?.phone?.code !=null){
              const country = this.countryData.find(x => x.CountryName === data.phone?.country);
              this.contactForm.patchValue({
               code:country,
              })
            }else{
              this.contactForm.patchValue({
                code:this.countryData.find(x => x.CountryName === 'USA'),
               })
            }
            if(this.selectedPhone){
              this.contactForm.patchValue({
                phone: this.selectedPhone?.phoneNumber,
                code: this.countryData.find(x => x.PhoneCode === this.selectedPhone?.countryCode),
              });
            }
          },
          error: (error) => {
            this.appMainService.isHideSpinner('authenSetUp');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.message : 'please try again...'
            });

          },
          complete: () => { },
        });
  }

  onCountrySelect(event: any) {
    this.selectedCountry = event.value;
    // this.contactForm.get('phone').reset();
  }

  async getPhoneNumberTemplate() {
    this.phoneNumberFormat = await this.phoneNumberFormatService.getPhoneNumberFormat();
    if(this.phoneNumberFormat){
        const phoneControl = this.contactForm.get('phone');
          phoneControl.markAsPristine();
          phoneControl.markAsUntouched();
    }
  }

  applyMaskAndValidators(maskValue?: string) {
    const phoneControl = this.contactForm.get('phone');
    if (phoneControl) {
        phoneControl.setValidators([
            Validators.required,
        ]);
        phoneControl.updateValueAndValidity();
    }
  }

  checkNumber(){
    return false;
  }
}
